<template>
  <div>
    <a-card
      :bordered="false"
      style="margin-bottom: 16px"
      :body-style="{ padding: '12px 16px 4px' }"
    >
      <div class="module-header-fs14" style="margin-bottom: 8px">工单情况</div>

      <div :size="16" class="statistic-card">
        <div class="ticket-item">
          <div>
            <div class="title">当日新建工单总数</div>
            <div class="value">
              {{
                isNotUndefined(ticketData?.service_created_today)
                  ? ticketData.service_created_today
                  : '-'
              }}
            </div>
          </div>
        </div>

        <div class="ticket-item">
          <div>
            <div class="title">当日已关闭工单</div>
            <div class="value">
              {{
                isNotUndefined(ticketData?.service_closed_today)
                  ? ticketData.service_closed_today
                  : '-'
              }}
            </div>
          </div>
        </div>

        <div class="ticket-item">
          <div>
            <div class="title">工单总数</div>
            <div class="value">
              {{
                isNotUndefined(ticketData?.service_total)
                  ? ticketData.service_total
                  : '-'
              }}
            </div>
          </div>
        </div>

        <div class="ticket-item">
          <div>
            <div class="title">工单超时响应数</div>
            <div class="value">
              {{
                isNotUndefined(ticketData?.service_timeout)
                  ? ticketData.service_timeout
                  : '-'
              }}
            </div>
          </div>
        </div>

        <div class="ticket-item">
          <div>
            <div class="title">工单闭环率</div>
            <div class="value">
              {{
                isNotUndefined(ticketData?.service_rate)
                  ? ticketData.service_rate
                  : '-'
              }}%
            </div>
          </div>
        </div>
      </div>

      <!-- Top -->
      <a-row v-show="visible" :gutter="16" class="top-container">
        <a-col :md="12" :xxl="8" style="margin-bottom: 16px">
          <div class="top-item">
            <div class="module-header-fs14" style="margin-bottom: 12px">
              工单平均关闭时效Top3
            </div>
            <div class="item-card">
              <template v-if="ticketTop && ticketTop.length">
                <alert-info-top unit="分" :detail="ticketTop"></alert-info-top>
              </template>

              <empty-component
                v-else
                :imgUrl="require('@/assets/images/info_empty.png')"
                :body-style="{
                  marginTop: '24px'
                }"
                :description-style="{
                  marginTop: '-8px',
                  marginRight: '8px'
                }"
                description="暂无数据"
              ></empty-component>
            </div>
          </div>
        </a-col>

        <a-col :md="12" :xxl="8" style="margin-bottom: 16px">
          <div class="top-item">
            <div class="module-header-fs14" style="margin-bottom: 12px">
              工单闭环率Bottom3
            </div>
            <div class="item-card">
              <template v-if="ticketBottom && ticketBottom.length">
                <alert-info-top
                  unit="%"
                  :detail="ticketBottom"
                ></alert-info-top>
              </template>

              <empty-component
                v-else
                :imgUrl="require('@/assets/images/info_empty.png')"
                :body-style="{
                  marginTop: '24px'
                }"
                :description-style="{
                  marginTop: '-8px',
                  marginRight: '8px'
                }"
                description="暂无数据"
              ></empty-component>
            </div>
          </div>
        </a-col>
      </a-row>

      <!-- 按钮 -->
      <div style="text-align: center">
        <a-button type="link" @click="changeDisplay">
          <a-icon v-show="!visible" type="caret-down" />
          <a-icon v-show="visible" type="caret-up" />
          <span>{{ visible ? '收起' : '展开' }}</span>
        </a-button>
      </div>
    </a-card>

    <a-card
      :bordered="false"
      style="margin-bottom: 16px"
      :body-style="{ padding: '16px' }"
    >
      <div class="table-operation-container">
        <a-space style="float: left">
          <datetime-range
            class="table-range"
            @ok="
              v => {
                datetimeRange = v
                fetch()
              }
            "
          ></datetime-range>
        </a-space>

        <a-space size="middle" style="float: right">
          <a-input-group :compact="true">
            <a-select
              v-model="searchType"
              :options="tableSearchOptions"
              style="min-width: 96px; border-right: 1px solid #fff"
            >
              <a-icon slot="suffixIcon" type="caret-down"></a-icon>
            </a-select>

            <a-input-search
              placeholder="请输入关键词"
              @search="v => handleSearch(v)"
              style="width: 160px"
            ></a-input-search>
          </a-input-group>
          <!-- 刷新 -->
          <reload-button @click="() => fetchTableData()"></reload-button>

          <!-- 导出 -->
          <export-button
            :columns="columnsAll"
            :default-selected="columnDefaultSelected"
            :export-func="exportFunc"
            :params="fetchParams"
            title="业务监控工单闭环情况"
          ></export-button>

          <!-- 设置 -->
          <setting-button
            :columns="columnsAll"
            :default-selected="columnDefaultSelected"
            @selected="v => (columns = v)"
          ></setting-button>
        </a-space>
      </div>

      <a-table
        rowKey="service_id"
        ref="table"
        class="custom-table scroll-hidden-table"
        :data-source="tableData"
        :columns="columns"
        :loading="loading"
        :scroll="{ x: scrollX }"
        :pagination="false"
        @change="handleTableChange"
      >
        <!-- 业务名字 -->
        <template slot="service_name" slot-scope="text">
          <template v-if="text">
            <a-tooltip :title="text">
              {{ text }}
            </a-tooltip>
          </template>
          <span v-else>-</span>
        </template>
        <!-- 责任处室 -->
        <template slot="organization_name" slot-scope="text">
          <template v-if="text">
            <a-tooltip :title="text">
              {{ text }}
            </a-tooltip>
          </template>
          <span v-else>-</span>
        </template>

        <span slot="today_average_close_time" slot-scope="text">
          {{ text }}分
        </span>

        <span slot="history_average_close_time" slot-scope="text">
          {{ text }}分
        </span>

        <span slot="today_closed_rate" slot-scope="text"> {{ text }}% </span>

        <span slot="history_closed_rate" slot-scope="text"> {{ text }}% </span>
      </a-table>

      <div style="height: 36px; margin-top: 16px">
        <a-pagination
          :current="fetchParams.page"
          :pageSize="fetchParams.page_size"
          :show-size-changer="true"
          :show-total="t => `共 ${t} 条`"
          :total="total"
          @change="
            page => {
              fetchParams.page = page
              fetchTableData()
            }
          "
          @showSizeChange="
            (_, pageSize) => {
              fetchParams.page = 1
              fetchParams.page_size = pageSize
              fetchTableData()
            }
          "
          style="float: right"
        ></a-pagination>
      </div>
    </a-card>
  </div>
</template>

<script>
import {
  getServiceStatus,
  getServiceTicketTop,
  getServiceTicketBottom,
  getServiceData,
  exportServiceData
} from '@/api/boss'
import DatetimeRange from '@/components/DatetimeRange'
import AlertInfoTop from '@/components/top/AlertInfoTop.vue'
import ExportButton from '@/components/button/ExportButton'
import ReloadButton from '@/components/button/ReloadButton'
import SettingButton from '@/components/button/SettingButton'
import EmptyComponent from '@/components/EmptyComponent.vue'
import { isNotUndefined } from '@/utils'

export default {
  name: 'ServiceTicket',
  components: {
    DatetimeRange,
    AlertInfoTop,
    ExportButton,
    ReloadButton,
    SettingButton,
    EmptyComponent
  },
  computed: {
    scrollX () {
      let sum = 0
      this.columns.forEach(column => {
        if (column?.children) {
          column.children.forEach(child => {
            sum += child.width
          })
        } else {
          sum += column.width
        }
      })
      return sum
    },
    params () {
      const obj = {}
      if (this.datetimeRange.length) {
        obj.datetime_from = this.datetimeRange[0].format('YYYY-MM-DD HH:mm')
        obj.datetime_to = this.datetimeRange[1].format('YYYY-MM-DD HH:mm')
      }
      return obj
    }
  },
  data () {
    return {
      isNotUndefined,
      fetchParams: {
        page: 1,
        page_size: 10
      },
      datetimeRange: [],
      searchType: 'service_name',
      tableSearchOptions: [{ label: '业务系统名称', value: 'service_name' }], // 表格搜索框搜索项
      loading: false, // 表格加载状态
      tableData: [], // 表格数据
      total: 0, // 表格数据总数
      exportFunc: exportServiceData,
      columnsAll: [
        {
          dataIndex: 'service_name',
          title: '业务系统名称',
          fixed: 'left',
          width: 160,
          ellipsis: true,
          scopedSlots: {
            customRender: 'service_name'
          }
        },
        {
          dataIndex: 'organization_name',
          title: '责任处室',
          width: 120,
          ellipsis: true,
          scopedSlots: {
            customRender: 'organization_name'
          }
        },
        {
          dataIndex: 'user_name',
          title: '运维公司对接人',
          width: 140,
          ellipsis: true,
          scopedSlots: {
            customRender: 'user_name'
          }
        },
        {
          title: '当日工单情况',
          children: [
            {
              dataIndex: 'today_created_today',
              title: '新建工单数',
              width: 140,
              scopedSlots: {
                customRender: 'today_created_today'
              },
              sorter: (a, b) => a.today_created_today - b.today_created_today
            },
            {
              dataIndex: 'today_closed_today',
              title: '已关闭工单数',
              width: 140,
              scopedSlots: {
                customRender: 'today_closed_today'
              },
              sorter: (a, b) => a.today_closed_today - b.today_closed_today
            },
            {
              dataIndex: 'today_average_close_time',
              title: '平均关闭时效',
              width: 140,
              scopedSlots: {
                customRender: 'today_average_close_time'
              },
              sorter: (a, b) =>
                a.today_average_close_time - b.today_average_close_time
            },
            {
              dataIndex: 'today_close_timeout',
              title: '超时响应数',
              width: 140,
              scopedSlots: {
                customRender: 'today_close_timeout'
              },
              sorter: (a, b) => a.today_close_timeout - b.today_close_timeout
            },
            {
              dataIndex: 'today_closed_rate',
              title: '工单闭环率',
              width: 140,
              scopedSlots: {
                customRender: 'today_closed_rate'
              },
              sorter: (a, b) => a.today_closed_rate - b.today_closed_rate
            }
          ]
        },
        {
          title: '历史工单情况',
          children: [
            {
              dataIndex: 'history_total',
              title: '历史工单总数',
              width: 140,
              scopedSlots: {
                customRender: 'history_total'
              },
              sorter: (a, b) => a.history_total - b.history_total
            },
            {
              dataIndex: 'history_closed',
              title: '历史已关闭',
              width: 140,
              scopedSlots: {
                customRender: 'history_closed'
              },
              sorter: (a, b) => a.history_closed - b.history_closed
            },
            {
              dataIndex: 'history_average_close_time',
              title: '历史平均关闭时效',
              width: 164,
              scopedSlots: {
                customRender: 'history_average_close_time'
              },
              sorter: (a, b) =>
                a.history_average_close_time - b.history_average_close_time
            },
            {
              dataIndex: 'history_timeout',
              title: '历史响应超时数',
              width: 152,
              scopedSlots: {
                customRender: 'history_timeout'
              },
              sorter: (a, b) => a.history_timeout - b.history_timeout
            },
            {
              dataIndex: 'history_closed_rate',
              title: '历史闭环率',
              width: 140,
              scopedSlots: {
                customRender: 'history_closed_rate'
              },
              sorter: (a, b) => a.history_closed_rate - b.history_closed_rate
            }
          ]
        }
      ],
      columnDefaultSelected: [
        'service_name',
        'organization_name',
        'user_name',
        'today_created_today',
        'today_closed_today',
        'today_closed_rate',
        'history_total',
        'history_closed_rate',
        'history_timeout',
        'history_closed_rate'
      ],
      columns: [],
      visible: false, // 更多统计展示
      closedTimeTopData: [], // 平均关闭时效top3
      closedBottomData: [], // 工单闭环bottom3
      statisticsDetail: {}, // 统计头数据
      ticketData: {}, // 工单情况数据
      ticketTop: [], // 工单平均关闭时效Top3
      ticketBottom: [] // 工单闭环率Bottom3
    }
  },
  mounted () {
    this.columns = []
    this.columnsAll.forEach(column => {
      if (column?.children) {
        const obj = {
          title: column.title,
          children: []
        }
        column.children.forEach(child => {
          if (this.columnDefaultSelected.indexOf(child.dataIndex) !== -1) {
            obj.children.push(child)
          }
        })
        this.columns.push(obj)
      } else {
        if (this.columnDefaultSelected.indexOf(column.dataIndex) !== -1) {
          this.columns.push(column)
        }
      }
    })
    this.fetch()
  },
  methods: {
    changeDisplay () {
      this.visible = !this.visible
    },
    fetch () {
      this.fetchStatus()
      this.fetchTop()
      this.fetchTableData()
    },
    fetchTableData () {
      this.loading = true
      getServiceData(this.fetchParams)
        .then(res => {
          const data = res.data
          if (data) {
            this.total = data.total
            this.tableData = data.data
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    fetchStatus () {
      const params = {}
      if (this.datetimeRange.length) {
        params.start = this.datetimeRange[0].format(
          'YYYY-MM-DD HH:mm:ss'
        )
        params.end = this.datetimeRange[1].format(
          'YYYY-MM-DD HH:mm:ss'
        )
      }
      getServiceStatus(params).then(res => {
        this.ticketData = res.data
      })
    },
    fetchTop () {
      const params = {}
      if (this.datetimeRange.length) {
        params.start = this.datetimeRange[0].format(
          'YYYY-MM-DD HH:mm:ss'
        )
        params.end = this.datetimeRange[1].format(
          'YYYY-MM-DD HH:mm:ss'
        )
      }
      getServiceTicketTop(params).then(res => {
        this.ticketTop = res.data?.data.map(item => {
          return {
            name: item.dept_name,
            value: item.time_cost
          }
        })
      })
      getServiceTicketBottom(params).then(res => {
        this.ticketBottom = res.data?.data.map(item => {
          return {
            name: item.dept_name,
            value: item.closed_rate
          }
        })
      })
    },
    handleSearch (value) {
      if (value !== '') {
        this.fetchParams[this.searchType] = value
      } else {
        delete this.fetchParams[this.searchType]
      }
      this.fetchParams.page = 1
      this.fetchTableData()
    },
    handleTableChange (pagination, filters, sorter) {
      const { order, field } = sorter

      if (order) {
        this.fetchParams.sort_by = field
        this.fetchParams.order_by = order
        if (order === 'ascend') this.fetchParams.order_by = 'asc'
        else if (order === 'descend') this.fetchParams.order_by = 'desc'
      } else {
        delete this.fetchParams.sort_by
        delete this.fetchParams.order_by
      }
      this.fetchParams.page = 1
      this.fetchTableData()
    }
  }
}
</script>

<style lang="less" scoped>
.statistic-card {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(188px, 1fr));
  gap: 16px;

  .ticket-item {
    color: #408bf3;
    width: 100%;
    height: 84px;
    border-radius: 6px;
    overflow: hidden;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-image: url('../../../assets/images/service-monitor/statistic-ticket.png');

    & > div {
      text-align: center;
      padding: 12px 0 0 6px;
      margin-right: 48px;
      overflow: hidden;

      .title {
        font-size: 12px;
      }

      .value {
        font-size: 30px;
        font-weight: 500;
      }
    }
  }
}
.top-container {
  margin-top: 22px;

  .top-item {
    .item-card {
      min-height: 164px;
    }
  }
}

.table-operation-container {
  height: 34px;
  margin-bottom: 16px;
  font-size: 16px;
  line-height: 34px;
  overflow: hidden;

  .table-range {
    height: 32px;
    & > :deep(.ant-calendar-picker-input) {
      height: 32px !important;
      .ant-calendar-range-picker-separator {
        vertical-align: baseline !important;
      }
    }
  }
}
</style>
